<template>
  <div class="box">
    <swiper></swiper>
    <el-menu
      style="border-bottom:none;height:50px;"
      mode="horizontal"
      background-color="#018FD7"
      text-color="#fff"
      active-text-color="#ffd04b"
      router
    >
      <template
        v-for="item in menu"
      >
        <el-menu-item v-if="item.categoryId == 262" index='/layout/main' style="height:50px;line-height:50px;">
          {{item.categoryTitle}}
        </el-menu-item>
        <!-- <el-menu-item v-else-if="item.categoryId == 259" :index="'/contact/259/'+$store.state.categoryAppid" style="height:50px;line-height:50px;">
          {{item.categoryTitle}}
        </el-menu-item> -->
        <el-menu-item v-else-if="(item.categoryId == 156|| item.categoryId == 259) && item.child.length==0" :index="'/layout/contact/'+item.categoryId+'/'+$store.state.categoryAppid" style="height:50px;line-height:50px;">
          {{item.categoryTitle}}
        </el-menu-item>
        <el-submenu v-else-if="(item.categoryId == 156|| item.categoryId == 259) && item.child.length!==0" :index="'/layout/contact/'+item.categoryId+'/'+$store.state.categoryAppid" style="height:50px;line-height:50px;">
          <template slot="title">
            <router-link style="color:#fff" :to="'/layout/contact/'+item.categoryId+'/'+$store.state.categoryAppid">{{item.categoryTitle}}</router-link>
          </template>
          <el-menu-item
            v-for="data in item.child"
            :key="data.categoryId"
            :index="'/layout/contact/'+ data.categoryId +'/'+$store.state.categoryAppid"
            style="height:50px;line-height:50px;"
          >
            {{data.categoryTitle}}
          </el-menu-item>
        </el-submenu>
        <el-submenu v-else-if="item.child.length!==0" :index="'/layout/news/'+ item.categoryId" style="height:50px;line-height:50px;">
          <template slot="title">
            <router-link style="color:#fff" :to="'/layout/news/'+ item.categoryId">{{item.categoryTitle}}</router-link>
          </template>
          <el-menu-item
            v-for="data in item.child"
            :key="data.categoryId"
            :index="'/layout/news/'+ data.categoryId"
            style="height:50px;line-height:50px;"
          >
            {{data.categoryTitle}}
          </el-menu-item>
        </el-submenu>

        <el-menu-item v-else :index="'/layout/news/'+ item.categoryId" style="height:50px;line-height:50px;">
          {{item.categoryTitle}}
        </el-menu-item>
      </template>
    </el-menu>

  </div>
</template>

<script>
import swiper from '@/components/Swiper'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    swiper
  },
  data() {
    return {
      menu: []
    }
  },
  computed: {
    ...mapGetters([
      'getCategoryAppid'
    ])
  },
  watch: {
    getCategoryAppid(id) {
      this.getMenu(id)
    }
  },
  created(){
    this.getMenu(this.$store.state.categoryAppid)
  },
  methods: {
    ...mapActions([
      'findAll'
    ]),
    getMenu(id) {
      let param = { categoryAppid: id, categoryType: '2'}
      this.findAll(param).then(res => {
        // console.log(res)
        var menu = []
        var child = []
        res.data.map(item => {
          if( item.categoryShowCover == 1 ) {
            if (item.categoryCategoryid === -1 && item.categorySort >-1) {
              menu.push(item)
            } else {
              child.push(item)
            }
          }
        })
        menu.map(data => {
          var aaa = child.filter(item => {
            return data.categoryId === item.categoryCategoryid
          })
          data.child = aaa
        })
        this.menu = menu
        this.setTitles(res.data)
        // console.log(menu)
      })
    },
    //生成目录id,名称，父栏目的映射表，保存到vuex
    setTitles(list) {
      var menu = []
      var child = []
      list.map(item => {
        if (item.categoryCategoryid === -1 && item.categorySort !== -1) {
          menu.push(item)
        } else {
          child.push(item)
        }
      })
      menu.map(data => {
        var aaa = child.filter(item => {
          return data.categoryId === item.categoryCategoryid
        })
        data.child = aaa
      })
      let categorys = []
      let titles = {}
      menu.map(item => {
        if(item.child.length == 0) {
          titles[item.categoryId] = {
            title: item.categoryTitle,
            parent: item.categoryId,
            parentTitle: item.categoryTitle
          }
          categorys.push(item.categoryId)
        } else {
          let parent = item.categoryId
          let parentTitle = item.categoryTitle
          titles[item.categoryId] = {
            title: item.categoryTitle,
            parent: item.categoryId,
            parentTitle: item.categoryTitle
          }
          categorys.push(item.categoryId)
          item.child.map(item => {
            titles[item.categoryId] = {
              title: item.categoryTitle,
              parent: parent,
              parentTitle: parentTitle
            }
            categorys.push(item.categoryId)
          })
        }
      })
      this.$store.commit('setTitles', titles)
      localStorage.setItem('categorys', categorys)
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  background: #018fd7;
}
.el-menu {
  // max-width: 1200px;
  margin: 0 auto;
  color: #fff;
}
</style>
